export enum EEnvPlatform {
  ip = 'ip',
  ad = 'ad',
  wam = 'wam',
  wad = 'wad',
}

export enum EEnvCountry {
  FR = 'FR',
  BE = 'BE',
  CHF = 'CHF',
  CHG = 'CHG',
  EN = 'EN',
  IE = 'IE',
  DE = 'DE',
  IT = 'IT',
  ES = 'ES',
  DK = 'DK',
  NO = 'NO',
  PT = 'PT',
  NL = 'NL',
  SE = 'SE',
  FI = 'FI',
}

export enum EEnvLocale {
  fr = 'fr',
  en = 'en',
  de = 'de',
  it = 'it',
  es = 'es',
  da = 'da',
  nb = 'nb',
  pt = 'pt',
  nl = 'nl',
  sv = 'sv',
  fi = 'fi',
}
